import './styles.css';
import { bootstrap } from './app.js';

const app = bootstrap();
app.start();
